import ReactDOM from 'react-dom/client';

import { Suspense } from 'react';
import { AppRouter } from './routers/app.router';
import { Loading } from './components/Loading';
import { ThemeProvider } from './theme';
import ErrorBoundary from './components/ErrorBoundary';

import './plugins';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

root.render(
    <ErrorBoundary>
        <Suspense fallback={<Loading />}>
            <ThemeProvider>
                <AppRouter />
            </ThemeProvider>
        </Suspense>
    </ErrorBoundary>,
);
